import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { IEvent } from '../../store/events/interfaces'

import { Badge, Col, Overlay, ProgressBar, Row, Tooltip } from 'react-bootstrap'
import { Dictionary } from '@reduxjs/toolkit'

export const EventCodeOccupation = (props: { event: IEvent }) => {
  const { event } = props
  const { data: program } = useSelector((state: RootState) => state.program)
  const targets = useRef<Array<HTMLDivElement | null>>([])
  const [shows, setShows] = useState<boolean[]>(
    new Array(event.accesskey_categories.length).fill(false),
  )
  const quotaRestrictionModes: Dictionary<string> = {
    hard: 'Begrenzung',
    soft: 'Reservierung',
  }

  const setShow = (idx: number) => (value: boolean) =>
    setShows(shows.map((show: boolean, key: number) => key === idx && value))
  return (
    <>
      {event.accesskey_categories.map((result, key) => (
        <Row key={key}>
          <Col
            md={12}
            className='d-flex justify-content-center align-items-start'
          >
            <Badge>
              {result.name}{' '}
              {program.booking_visibility_codes === 'detailed' ||
              program.booking_visibility_codes === 'all'
                ? program.booking_visibility_codes === 'all'
                  ? `${result.used}/${result.quota} ${
                    quotaRestrictionModes[result.quota_type]
                  }`
                  : `${result.used}/${result.quota}`
                : ''}
            </Badge>
          </Col>
          <Col md={{ span: 10, offset: 1 }}>
            <div
              ref={el => (targets.current[key] = el)}
              tabIndex={-1}
              onClick={() => setShow(key)(!shows[key])}
              onBlur={() => (shows[key] ? setShow(key)(!shows[key]) : null)}
            >
              <ProgressBar
                variant={
                  result.used / result.quota < 1 && result.quota !== 0
                    ? 'success'
                    : 'danger'
                }
                aria-label='Belegung nach Geschlecht'
                now={
                  program.booking_visibility_codes === 'bars_color_only' ||
                  result.quota === 0
                    ? 100
                    : (result.used / result.quota) * 100
                }
                className='mb-2'
              />
            </div>
            {targets.current[key] && (
              <Overlay
                target={targets.current[key]}
                show={shows[key]}
                placement='bottom'
              >
                {(props: any) => (
                  <Tooltip {...props}>
                    {result.used / result.quota < 1
                      ? 'Diese Kategorie hat freie Plätze.'
                      : 'Diese Kategorie ist vollständig besetzt.'}
                  </Tooltip>
                )}
              </Overlay>
            )}
          </Col>
        </Row>
      ))}
    </>
  )
}
